import styled from "styled-components";

export type ReportSort = { key: string; dir: "asc" | "desc" } | null;

/**
 * Sıralanabilir kolon başlığı.
 *
 * Eski tablolarda ok bir PNG'ydi ve sıralama kapalıyken bile "aşağı ok"
 * gösteriyordu — kolon sıralıymış gibi duruyordu. Artık aktif kolon ↑/↓,
 * sıralanabilir ama pasif kolon ↕ ile işaretleniyor.
 */
export const sortHeader = (
  label: string,
  sort: ReportSort,
  key: string
): string => {
  // Bölünemez boşluk: "ERKEN ÇIKILAN ↕" iki satıra kayınca ok tek başına
  // alt satıra düşüyor ve başlık satırı yükseliyordu.
  const arrow = sort?.key !== key ? "↕" : sort.dir === "asc" ? "↑" : "↓";
  return `${label}\u00A0${arrow}`;
};

/** Tablo başlığının altındaki "Toplam N kayıt" satırı. */
export const ResultCount = ({ total }: { total: number }) => (
  <CountText>
    Toplam <strong>{total}</strong> kayıt
  </CountText>
);

const CountText = styled.div`
  font-size: 13px;
  color: #64748b;

  strong {
    color: #334155;
    font-weight: 600;
  }
`;
